// extracted by mini-css-extract-plugin
module.exports = {"root":"FetchDataWrapper_root__28EbA","empty":"FetchDataWrapper_empty__2cGyL"};